import React from 'react';
import {
  DollarIconWrapper,
  DollarIconS,
  DollarIconBorder,
  StrikeThrough,
} from './DollarIcon.styles';

const DollarIcon = () => (
  <DollarIconWrapper xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.71 28">
    <DollarIconBorder d="M15.41,1.86l.31.16L16.07,2l1.56-.31,1.14,1.1L19,3l.35,0L21,3.17l.79,1.38.17.31.33.12,1.48.59.37,1.55.08.34.28.21,1.25,1-.08,1.59,0,.35.2.29.93,1.29-.52,1.5L26.1,14l.12.33.52,1.5-.93,1.29-.2.29,0,.35.08,1.59-1.25,1-.28.21-.08.34-.37,1.55L22.25,23l-.33.12-.17.31L21,24.83,19.38,25,19,25l-.26.24-1.14,1.1L16.07,26,15.72,26l-.31.16L14,26.87l-1.41-.73L12.28,26l-.35.06-1.56.31-1.14-1.1L9,25l-.35,0L7,24.83l-.79-1.38-.17-.31L5.75,23l-1.48-.59L3.9,20.88l-.08-.34-.28-.21-1.25-1,.08-1.59,0-.35-.2-.29-.93-1.29.52-1.5L1.9,14l-.12-.33-.52-1.5.93-1.29.2-.29,0-.35L2.29,8.65l1.25-1,.28-.21.08-.34.37-1.55L5.75,5l.33-.12.17-.31L7,3.17,8.62,3,9,3l.26-.24,1.14-1.1L11.93,2l.35.06.31-.16L14,1.13Z" />
    <StrikeThrough x="12.45" y="6.01" width="2" height="4" rx="1" />
    <DollarIconS d="M10.23,18.72a1.26,1.26,0,0,1,0-1.48.92.92,0,0,1,1.28-.47,4.38,4.38,0,0,0,2.39.92,1.06,1.06,0,0,0,1.17-1c0-.7-.62-1.16-1.75-1.68-1.61-.79-3.25-1.68-3.25-3.68C10.07,9.67,11.37,8,14,8a6.32,6.32,0,0,1,3.6,1.25c.2.11.07.89-.23,1.3s-.93.82-1.27.63a4.51,4.51,0,0,0-2.27-.91.92.92,0,0,0-1,.92c0,.56.66,1,1.84,1.56,1.49.72,3.4,1.52,3.4,3.79A3.68,3.68,0,0,1,14,20,5.37,5.37,0,0,1,10.23,18.72Z" />
    <StrikeThrough x="12.86" y="17.99" width="2" height="4" rx="1" />
  </DollarIconWrapper>
);

export default DollarIcon;
